/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type StocklotsResultDTO = {
    shopSourceName?: string;
    shopSourceVatType?: StocklotsResultDTO.shopSourceVatType;
    shopProductName?: string;
    sku?: string;
    shopProductType?: StocklotsResultDTO.shopProductType;
    cost?: number;
    quantity?: number;
    createdAt?: string;
    actionBy?: string;
    inventoryTransactionId?: string;
    actionByFirstName?: string;
    actionByLastName?: string;
    imeis?: string;
    displayCost?: string;
    totalCost?: number;
    totalVat?: number;
};
export namespace StocklotsResultDTO {
    export enum shopSourceVatType {
        VAT = 'VAT',
        NON_VAT = 'NON_VAT',
    }
    export enum shopProductType {
        GENERAL = 'GENERAL',
        MOBILE = 'MOBILE',
    }
}

